// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__32xbr","range":"MonthRangeSwitch_range__ZZP6n","disabled":"MonthRangeSwitch_disabled__BKIMy"};